/**
 * Central configuration file
 *
 * Switch between localhost development and production by changing IS_PRODUCTION
 * No .env file needed - just edit this file manually
 */

// ============================================
// SWITCH THIS TO TRUE FOR PRODUCTION
// ============================================
export const IS_PRODUCTION = false;

/**
 * The API lives on its own subdomain, separate from the app itself, so this
 * has to be an absolute URL rather than a bare "/api" path.
 *
 * Because that makes every request cross-origin, the session cookie only
 * survives if the API sends `Access-Control-Allow-Origin: https://drums.isseylab.com`
 * with `Access-Control-Allow-Credentials: true`, and sets the cookie
 * `SameSite=None; Secure; Domain=.isseylab.com`.
 */
export const API_BASE_URL = IS_PRODUCTION
  ? 'https://drums-api.isseylab.com/api'  // Production API endpoint (subdomain)
  : 'http://localhost:3002/api';          // Development API endpoint

// Full base URL (without /api)
export const BASE_URL = IS_PRODUCTION
  ? 'https://drums-api.isseylab.com'
  : 'http://localhost:3002';
